<template>
    <vx-button @click.prevent="onClick" data-test="ai-cost-optimization" color="transparent" type="button">
        <span class="flex items-center gap-1">
            <font-awesome-icon widthAuto :icon="faWandMagicSparkles" class="text-sm"></font-awesome-icon>
            <span>Cost-Optimized</span>
            <experimental-pill static></experimental-pill>
        </span>
    </vx-button>
</template>

<script lang="ts" setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons';
import ExperimentalPill from '~/components/general/ExperimentalPill.vue';
import { pendoEvent, trackPendoEvent } from '~/utils/pendo';

const emit = defineEmits<{
    click: [];
}>();

const onClick = () => {
    trackPendoEvent(
        pendoEvent('Quick Blast Cost Optimized', {
            team_id: Spark.state.currentTeam.id,
            group_id: Spark.state.currentGroup?.group_id ?? null,
        })
    );
    emit('click');
};
</script>
